"use client";

import { useEffect, useState } from "react";
export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden flex items-center">
      {}
      <div className={`absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542868/img/image_q8edk6s0.jpg)] transition-transform duration-[8000ms] ease-out ${isLoaded ? "scale-105" : "scale-100"}`} />

      {}
      <div className="surface-overlay" />

      {}
      <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        {}
        <div className="lg:col-span-7 space-y-6">
          <h1 className={`font-display text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight tracking-tight transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: "100ms"
        }}>
            Discover France Without Breaking the Bank
          </h1>
          
          {}
          <div className={`flex flex-wrap gap-4 max-w-2xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: "200ms"
        }}>
            {}
          </div>
        </div>

        {}
        <div className={`lg:col-span-5 flex flex-col sm:flex-row gap-4 justify-start lg:justify-end transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: "300ms"
      }}>
        </div>
      </div>
    </section>;
}